import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Button from "components/CustomButtons/Button.jsx";


import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { verifyDecimal } from "../../assets/helpers/formHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';
import { convertToCurrency } from "../../assets/helpers/dataHelper";
import Slider from '@material-ui/core/Slider';
import createTheme from '@material-ui/core/styles/createTheme';
import { ThemeProvider } from '@material-ui/core/styles';

const customSliderTheme = createTheme({
  overrides: {
    MuiSlider: {
      mark: { visibility: 'hidden' },
    },
  }
});

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle,
  ...sweetAlertStyle
};

const discountSliderMarks = [
  {
    value: 3,
    label: 'conservative',
  },
  {
    value: 47,
    label: 'aggressive',
  },
];

class FeeCalculator extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      fees: [{ code: 'loading...', fee: 'loading...', freq: ''}],
      discount: 0,
      monthlyFee: 'loading...',
      feeFreqOptions: [],
      inputDisabled: true,
      submitFeesButtonDisabled: false,
      alert: null
    };

  }
  componentDidMount() {
    this._isMounted = true;
    this.getFeeInfo()
    this.getFeeFreqOptions()
  }



  getFeeInfo() {
    axios.get(`${API_ROOT}/marketing/feeCalculator/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setFeeInfo(res.data));
  }

  setFeeInfo(res) {
    if (!res.error) {
      this.setState({
        fees: res.fees,
        discount: res.discount * 100,
        monthlyFee: res.monthlyFee,
        inputDisabled: false
      })
    }
  }

  getFeeFreqOptions() {
    axios.get(`${API_ROOT}/marketing/feeFreq/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setFeeFreqOptions(res.data));
  }

  setFeeFreqOptions(res) {
    if (!res.error) {
      this.setState({
        feeFreqOptions: res
      })
    }
  }

  handleFeeChange(event, index, field) {
    var fees = this.state.fees
    fees[index][field] = event.target.value

    this.setState({
      fees: fees
    })
  }

  onSubmitFees() {
    var validFees = true
    for (var feeItem in this.state.fees) {
      var fee = this.state.fees[feeItem]['fee']
      if (fee !== '' && !verifyDecimal(fee)) {
        validFees = false
        break
      }
    }

    if (!validFees) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="entry warning"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            confirmBtnText="okay"
          >
            Please enter only numbers in the fee field.
          </SweetAlert>
        )
      });
    } else {
      const fees = JSON.stringify(this.state.fees)
      const feesData = {
        fees: fees,
        discount: this.state.discount,
        userId: this.state.userId
      }
      axios.post(`${API_ROOT}/marketing/feeCalculator/`, feesData, { headers: getApiHeaders() })
        .then(res => this.handleFeesPlan(res.data));
    }
  }

  handleFeesPlan(res) {
    this.setState({
      monthlyFee: res.monthlyFee
    })
  }

  handleDiscountChange(event, value) {
    this.setState({
      discount: value
    })
  }

  handleAddRow = () => {
    this.setState({
      fees: this.state.fees.concat([{ code: '', fee: '', freq: ''}])
    }, () => {
      this.scrollToBottomOfFeeEntry();
    });
    //feeEntryDiv

  }

  scrollToBottomOfFeeEntry() {
    const feeEntryElement = document.getElementById('feeEntryDiv')
    // feeEntryElement.scrollTo(0, feeEntryElement.scrollHeight)
    feeEntryElement.scrollTo({
                        top: feeEntryElement.scrollHeight,
                        left: 0,
                        behavior: 'smooth'
    })
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <GridContainer>
          {this.state.alert}
          <GridItem xs={12} sm={12}>
            Enter your standard fees and the frequency of the service, and we'll help you determine the monthly fee to charge.
            <hr />
          </GridItem>
          <GridItem xs={12} sm={7} md={7}>
            <div id="feeEntryDiv" style={{height: '300px', overflow: 'auto'}}>
              {this.state.fees.map((fee, idx) => (
                <GridContainer key={idx}>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="code/description"
                      type="text"
                      id="code{idx}"
                      inputProps={{
                        onChange: event => this.handleFeeChange(event, idx, 'code'),
                        value: fee.code,
                        disabled: this.state.inputDisabled
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="fee"
                      type="text"
                      id="fee{idx}"
                      inputProps={{
                        onChange: event => this.handleFeeChange(event, idx, 'fee'),
                        value: fee.fee,
                        disabled: this.state.inputDisabled
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        frequency
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={fee.freq}

                        inputProps={{
                          id: "freq{idx}",
                          name: "freq{idx}",
                          onChange: event => this.handleFeeChange(event, idx, 'freq')
                        }}

                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          choose frequency
                        </MenuItem>
                        {this.state.feeFreqOptions.map((feeFreq) =>
                          <MenuItem classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }} key={feeFreq[0]} value={feeFreq[0]} >{feeFreq[1]}</MenuItem>
                        )}

                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              ))}
            </div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  onClick={this.handleAddRow}
                  color="cirrusBlue"
                  disabled={this.state.inputDisabled}
                  id="addRowButton"
                >
                  Add row
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={5} md={5}>


            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                Membership discount pricing strategy
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <ThemeProvider theme={customSliderTheme}>
                  <Slider
                      min={0}
                      max={50}
                      value={this.state.discount}
                      id='discount'
                      onChange={this.handleDiscountChange.bind(this)}
                      marks={discountSliderMarks}
                      style={{marginLeft: "5%", width: "90%"}}
                  />
                </ThemeProvider>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  onClick={this.onSubmitFees.bind(this)}
                  color="cirrusBlue"
                  id="submitFeesButton"
                  disabled={this.state.submitFeesButtonDisabled}
                >
                  calculate subscription fee
                </Button>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <h4>base subscription price:</h4>
                {convertToCurrency(this.state.monthlyFee)}/month
              </GridItem>
            </GridContainer>



          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(FeeCalculator);
